@if (isVisible() && currentStep(); as step) {
<!-- Visual Overlay with Hole -->
<div class="product-tour-overlay" [style.clip-path]="clipPath()"></div>

<!-- Stylized Highlight Box (Rounded corners + Glow) -->
<div
  class="product-tour-highlight-box"
  [style.top.px]="highlightRect()?.top! - 8"
  [style.left.px]="highlightRect()?.left! - 8"
  [style.width.px]="highlightRect()?.width! + 16"
  [style.height.px]="highlightRect()?.height! + 16"
></div>

<!-- Global Interaction Blocker (no hole) -->
<div class="product-tour-global-blocker"></div>

<!-- Tour UI -->
<div
  #tooltip
  class="tour-tooltip"
  [class]="'pos-' + (step.position || 'bottom')"
  [style.top.px]="tooltipPos()?.top"
  [style.left.px]="tooltipPos()?.left"
  aria-modal="true"
  role="dialog"
>
  <div class="tour-header">
    <span class="tour-steps"
      >{{ 'tourFeature' | translate }} {{ currentIndex() + 1 }} {{ 'of' | translate }} {{ totalSteps() }}</span
    >
    <h2 class="tour-title">{{ step.title | translate }}</h2>
  </div>

  <div class="tour-description">
    {{ step.description | translate }}
  </div>

  <div class="tour-footer">
    <button class="btn-skip" (click)="skip()">{{ 'skip' | translate }}</button>

    <div class="nav-buttons">
      @if (currentIndex() > 0) {
      <button class="tour-btn btn-prev" (click)="previous()">{{ 'prev' | translate }}</button>
      }

      <button class="tour-btn btn-next" (click)="next()">
        {{ currentIndex() === totalSteps() - 1 ? ('finish' | translate) : ('next' | translate) }}
      </button>
    </div>
  </div>
</div>
}
